import { ROUTES } from "./constants";

/**
 * Builds the URL for the Published Assignment screen by replacing the `:planId`
 * placeholder in `ROUTES.SHIFT_ROTATION_PUBLISHED` with the supplied value.
 *
 * The plan's shift context — `ofdDate` (OFD date, `YYYY-MM-DD`) and `shift`
 * (`day` / `night`) — is carried as query params so the Published screen can
 * render the correct date / clock-window and fetch the correct plan. They are
 * optional: a URL without them still resolves (the Published screen falls back
 * to sensible defaults for direct/deep-link access), and any missing/blank
 * value is simply omitted from the query string.
 */
export const buildStationAssignmentPublishedUrl = (
  planId: string,
  options?: { ofdDate?: string; shift?: string },
): string => {
  const base = ROUTES.SHIFT_ROTATION_PUBLISHED.replace(":planId", planId);
  const params = new URLSearchParams();
  if (options?.ofdDate) params.set("ofdDate", options.ofdDate);
  if (options?.shift) params.set("shift", options.shift);
  const query = params.toString();
  return query ? `${base}?${query}` : base;
};

/**
 * Returns the route of the first tab in the station assignment workflow.
 *
 * The first tab is the new Planned Headcount screen, which has replaced the
 * legacy Shift Roster screen across all environments.
 */
export const getStationAssignmentFirstTabRoute = (): string =>
  ROUTES.SHIFT_ROTATION_PLANNED_HC;
